import { ThunkMiddleware } from 'redux-thunk';
import { NavisionExport } from '@inter-ikea-kompis/navision-export';
import { Actions, RootState } from '..';
import { SET_SHOPPING_ITEMS } from '../sofaConfiguration';
import { APP_INIT } from '../application/types';

const navisionExport = new NavisionExport();

const navisionMiddleware: ThunkMiddleware<RootState, Actions> =
	(api) =>
	(next) =>
	(action: Actions): Actions => {
		const result = next(action);
		switch (action.type) {
			case APP_INIT: {
				navisionExport.connect();
				break;
			}
			case SET_SHOPPING_ITEMS: {
				const shoppingItems = api.getState().sofaConfiguration.shoppingItems;
				const formattedShoppingItems = shoppingItems.map((shoppingItem) => {
					return {
						id: shoppingItem.id,
						type: shoppingItem.type,
						quantity: shoppingItem.quantity,
					};
				});

				navisionExport.setShoppingItems(formattedShoppingItems);
				break;
			}
		}
		return result;
	};

export { navisionMiddleware };
